import react, { useEffect, useState } from 'react';
import DefaultLoader from '../../../components/loader/DefaultLoader';
import axios from 'axios';
import {useCookies} from 'react-cookie';
import NullPlayer from '../../../assets/img/player/null.png';
import { useTranslation } from 'react-i18next';

function PlayerProfile({profile}) {
    const [cookies] = useCookies(['hiball_token']);
    let [profileObj, setProfileObj] = useState({});

    const { t } = useTranslation();
    let useLang = localStorage.getItem("language");

    useEffect(() => {
        const season = new Date().getFullYear();
        let playerId = profile['playerId'];
        axios({
            url : `${process.env.REACT_APP_API_URL}`,
            params: {
                recordType: 'digestRecord', recordName: 'selectProfile',
                batterIds: playerId,
                seasons: season,
                authToken:JSON.stringify(cookies['hiball_token'])
            }
        }).then((result) => {
            let {batter, pitcher} = result['data']['result'][0];
            let flatResult = {
                ...batter, ...pitcher
            }

            let season = new Date().getFullYear();
            let birthdateYear = flatResult['birthdate'] && flatResult['birthdate'].split('/');
            let age = (season*1-birthdateYear[0]*1)-1;

            flatResult['age'] = age;
            if(flatResult['weight'] && flatResult['height']) {
                if(useLang === "en"){
                    flatResult['playerEngInfo'] = `${flatResult['height']}cm ${flatResult['weight']}kg / Age:${flatResult['age']}(${flatResult['birthdate']})`;
                } else {
                    flatResult['playerInfo'] = `${flatResult['height']}cm ${flatResult['weight']}kg / ${flatResult['age']}세(${flatResult['birthdate']})`;
                }
            } else {
                if(useLang === "en"){
                    flatResult['playerEngInfo'] = `Age:${flatResult['age']}(${flatResult['birthdate']})`;
                } else {
                    flatResult['playerInfo'] = `${flatResult['age']}세(${flatResult['birthdate']})`;
                }
            }
            setProfileObj(flatResult);
        })
    }, []);

    function onErrorHandler(event) {
        event.target.src = NullPlayer;
    }

    if(Object.keys(profileObj).length === 0 ) {
        return <DefaultLoader />
    }

    return (
        <>
        <div className={'profileImageBox team'+profile['teamId']}>
            <div className="profileImage">
                <img src={`https://image.hanwha.kbostat.net/profileImage/${profile['playerId']}.jpg`} 
                onError={onErrorHandler} alt="#"/>
            </div>
            <div className="playerNameBox">
                <div className="playerName" style={{fontSize:"15px"}}>
                    {useLang === "en" ? profileObj['firstName'] + " " + profileObj['lastName'] : profileObj['batterName']}
                </div>
                <div className="playerPitchingType">
                    {t(profileObj['pitchingHand'])}{t('투')}
                    {t(profileObj['battingHand'])}{t('타')}
                </div>
                <div className="playerBacknumber">
                    {useLang ==="en" ? profileObj['englishBatterTeamName'] : profileObj['batterTeamName']} No.{profileObj['backNumber']}
                </div>
            </div>
        </div>
        {/* <div className="profileInfo">
            {useLang === "en" ? profileObj['playerEngInfo'] : profileObj['playerInfo']}
        </div> */}
        </>
    )
}

export default PlayerProfile;